import script from "./DetailSpecQuotation.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailSpecQuotation.vue?vue&type=script&setup=true&lang=js"

import "./DetailSpecQuotation.vue?vue&type=style&index=0&id=4613f403&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4613f403"]])

export default __exports__